
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.438.271V3.75h3.478L10.437.27z","fill":"#6C6C6C"}}),_c('path',{attrs:{"d":"M14.188 4.688H9.5V0H2v16h12.188V4.687z","fill":"#6C6C6C"}})])
          )
        }
      }
    